import isMatch from 'lodash-es/isMatch'
import { prop } from './prop'
import { Props } from './types'

const resolveFn = (props: Props, test: (props: Props) => any): boolean =>
  Boolean(test(props))

const resolveProps = (props: Props, test: Props): boolean => {
  return isMatch(props, test)
}

const resolveString = (props: Props, test: string): boolean =>
  Boolean(prop(test)(props))

const resolvers = {
  function: resolveFn,
  object: resolveProps,
  string: resolveString,
}
export const ifProp =
  <T extends Props = Props>(
    predicate: ((props: T) => any) | Partial<T>,
    pass: any = '',
    fail: any = ''
  ) =>
  (props: T) => {
    const result = resolvers[typeof predicate](props, predicate)
    const handler = result ? pass : fail
    return typeof handler === 'function' ? handler(props) : handler
  }

export default ifProp
